import type { ListeTableFilterData } from '@mairistem/liste';
import React from 'react';

import type { FactureType } from '@/types';

export type FactureContextType = {
  total: number;
  factures: FactureType[];
  filters: ListeTableFilterData[];
  search: string;
  sorts: Record<string, 'asc' | 'desc'>;
  setFactures: React.Dispatch<React.SetStateAction<FactureType[]>>;
  setFilters: React.Dispatch<React.SetStateAction<ListeTableFilterData[]>>;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  setSorts: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setTotal: React.Dispatch<React.SetStateAction<number>>;
  getFactures: () => void;
  applyDefaultFilters: () => void;
};

const FactureContext = React.createContext<FactureContextType>({
  total: 0,
  factures: [],
  filters: [],
  search: '',
  sorts: {},
  setFactures: () => {},
  setFilters: () => {},
  setSearch: () => {},
  setSorts: () => {},
  setPage: () => {},
  setTotal: () => {},
  getFactures: () => {},
  applyDefaultFilters: () => {},
});

export default FactureContext;
